import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store.js'
import vuetify from './plugins/vuetify';

import { VueMasonryPlugin } from "vue-masonry";
import JsonViewer from 'vue-json-viewer/ssr'
import 'vue-json-viewer/style.css'
//import VueSignaturePad from "vue-signature-pad";

Vue.config.productionTip = false

Vue.use(VueMasonryPlugin)
Vue.use(JsonViewer)
Vue.use(require('vue-moment'));
//Vue.use(VueSignaturePad)


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
